import Styled, { css } from 'styled-components';

import { SVGIconStyleWrapper } from '../../../Icon/SVGIcon';
import { cssDeclaration } from '../../Utils';
import { IHoveredProps, IInputError } from '../common';
import { BaseInputStyles, InputContainer } from '../TextInput/InputStyles';

export const StyledSelectInput = Styled.select`
  ${BaseInputStyles}
  cursor: pointer;
`;

export const SelectInputContainer = Styled(InputContainer as 'div')<IInputError & IHoveredProps>`

    ${({ theme: { themeTwo }, error, isHovered }) => {
      const size = themeTwo.global.edgeSize[themeTwo.form.select.icon.size] || themeTwo.form.select.icon.size;
      const iconOffset = themeTwo.global.edgeSize[themeTwo.form.input.padding.horizontal] || themeTwo.form.input.padding.horizontal;

      return css`
        ${StyledSelectInput} {
          padding-right: calc(${size} + ${iconOffset});
        }

        ${SVGIconStyleWrapper} {
          height: ${size};
          width: ${size};
          right: ${iconOffset};
          /* color */ ${themeTwo.form.select.icon.color && cssDeclaration(themeTwo, 'color', themeTwo.form.select.icon.color)};

          ${error && themeTwo.form.select.icon.errorColor && css`
          /* color */ ${cssDeclaration(themeTwo, 'color', themeTwo.form.select.icon.errorColor)};
          `}

          ${isHovered && css``}
        }
      `;
    }}
  }
`;
